export class IngestionPipelineStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<IngestionPipelineStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<IngestionPipelineStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
